import React from 'react';
import Button from 'react-bootstrap/Button';
import PropTypes from 'prop-types';

const LoginButton = ({ children, changeEv }) => {
    return (
        <Button variant="link" onClick={() => changeEv('login')}>
            {children}
        </Button>
    );
};

LoginButton.propTypes = {
    changeEv: PropTypes.func.isRequired,
    children: PropTypes.any.isRequired,
};

export default LoginButton;
